import Dashboard from "../../components/Dashboard";
import PurchaseOrdersPage from "../../components/PurchaseOrdersPage";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ReceiptIcon from "@mui/icons-material/Receipt";

export const housekeepingConfig = [
  {
    path: "/",
    component: Dashboard,
    label: "Dashboard",
    icon: DashboardIcon,
    showInNav: true,
  },
  {
    path: "/orders",
    component: PurchaseOrdersPage,
    label: "Orders",
    icon: ReceiptIcon,
    showInNav: true,
  },
];

export const housekeepingMetadata = {
  roleName: "Housekeeping",
  defaultRoute: "/",
};
